import { NAME } from './constants'

export const getQuestionsList = (state) => state[NAME].questionsList
